var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoAbi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 110,
    height: 18.431,
    viewBox: "0 0 110 18.431",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9686",
    "data-name": "Trazado 9686",
    d: "M1.123,13.755A9.253,9.253,0,0,0,7.815,18.43c-.1-2.858-2.416-5.737-5.921-6.994a10.568,10.568,0,0,0-1.771-.464,9.244,9.244,0,0,0,1,2.783M9.246,11.41a10.544,10.544,0,0,0,2.138,6.879A9.272,9.272,0,0,0,15.351,2.3a10.581,10.581,0,0,0-6.1,9.108M4.752,1.158A9.261,9.261,0,0,0,0,8.473a9.6,9.6,0,0,0,2.227.064A9.427,9.427,0,0,0,10.846.143,9.25,9.25,0,0,0,4.752,1.158",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    y1: 1,
    x2: 0.05,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d3a238"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.057,
    stopColor: "#d7aa31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.259,
    stopColor: "#e4c11c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.474,
    stopColor: "#edd20e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.709,
    stopColor: "#f3dc05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f5e003"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2027",
    "data-name": "Rect\\xE1ngulo 2027",
    width: 100,
    height: 18.43,
    transform: "translate(0 0)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_21532",
    "data-name": "Grupo 21532",
    transform: "translate(-1384 -829)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_21531",
    "data-name": "Grupo 21531",
    transform: "translate(1389 829.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_21528",
    "data-name": "Grupo 21528"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_21527",
    "data-name": "Grupo 21527",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2025",
    "data-name": "Rect\\xE1ngulo 2025",
    width: 19.826,
    height: 18.429,
    transform: "translate(0 0.001)",
    fill: "url(#linear-gradient)"
  }))), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2026",
    "data-name": "Rect\\xE1ngulo 2026",
    width: 2.673,
    height: 15.445,
    transform: "translate(49.092 1.346)",
    fill: "#010101"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_21530",
    "data-name": "Grupo 21530"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_21529",
    "data-name": "Grupo 21529",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9687",
    "data-name": "Trazado 9687",
    d: "M59.83,5.578A3.811,3.811,0,0,0,56.4,7.42V5.813H54V16.791h2.573V10.976a5.213,5.213,0,0,1,.121-1.209,2.3,2.3,0,0,1,2.381-1.872,2.088,2.088,0,0,1,2.261,1.927,6.913,6.913,0,0,1,.084,1.152v5.817h2.574V10.3a6.825,6.825,0,0,0-.243-1.951,3.792,3.792,0,0,0-3.92-2.766",
    fill: "#010101"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9688",
    "data-name": "Trazado 9688",
    d: "M74.6,8.536A3.494,3.494,0,0,0,76.08,5.5,3.973,3.973,0,0,0,73,1.552a9.235,9.235,0,0,0-2.179-.206H65.942V16.791h5.467a7.061,7.061,0,0,0,2.48-.349,4.279,4.279,0,0,0,3.1-4.157A3.922,3.922,0,0,0,74.6,8.536M68.586,3.77h2.373a3.884,3.884,0,0,1,1.486.245A1.693,1.693,0,0,1,73.436,5.7a1.723,1.723,0,0,1-1.027,1.705,3.487,3.487,0,0,1-1.362.225H68.586Zm4,10.506a5.443,5.443,0,0,1-1.046.09H68.586V10.011h3.182a4.178,4.178,0,0,1,.842.081,2.127,2.127,0,0,1-.02,4.184",
    fill: "#010101"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9689",
    "data-name": "Trazado 9689",
    d: "M97.239,5.813l-2.748,7.843L91.7,5.813H88.913l4.36,10.978h2.376L100,5.813Z",
    fill: "#010101"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9690",
    "data-name": "Trazado 9690",
    d: "M83.492,5.578a5.594,5.594,0,0,0-5.553,5.8A5.617,5.617,0,0,0,83.6,17.025a5.505,5.505,0,0,0,5.185-3.6H86.17a2.829,2.829,0,0,1-2.525,1.36,3.052,3.052,0,0,1-3.16-2.547h8.568a5.345,5.345,0,0,0,.078-1.042,5.59,5.59,0,0,0-5.639-5.616m-3,4.86a3.077,3.077,0,0,1,6.085,0Z",
    fill: "#010101"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9691",
    "data-name": "Trazado 9691",
    d: "M45.118,8.558A3.739,3.739,0,0,0,46.625,5.5a3.971,3.971,0,0,0-3.078-3.946,9.241,9.241,0,0,0-2.179-.206H36.486V7.863a23.565,23.565,0,0,0-3.939.95L29.5,1.346H27.047l-6.3,15.445h2.571a21.63,21.63,0,0,1,7.639-5.154l1.932,5.154H35.8L33.361,10.81a24.134,24.134,0,0,1,3.125-.67v6.651h1.327v0h4.66c3.294,0,5.061-1.932,5.061-4.508a4.04,4.04,0,0,0-2.416-3.729M24.81,13.283,28.241,4.4l2,5.325a20.986,20.986,0,0,0-5.428,3.557M39.13,3.771H41.4a4.242,4.242,0,0,1,1.25.156A1.869,1.869,0,0,1,43.981,5.9a1.888,1.888,0,0,1-1.263,1.9,14.937,14.937,0,0,0-2.48-.2c-.345,0-.724.006-1.108.018Zm3.181,10.594H39.13V9.926c.4-.017.8-.026,1.181-.022,2.893.038,4.576.879,4.576,2.378,0,1.348-1.206,2.083-2.576,2.083",
    fill: "#010101"
  })))), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2028",
    "data-name": "Rect\\xE1ngulo 2028",
    width: 110,
    height: 18.43,
    transform: "translate(1384 829)",
    fill: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoAbi);
export default __webpack_public_path__ + "static/media/logo-abi.b129d707b20f32ee1673ee1dce09b6d1.svg";
export { ForwardRef as ReactComponent };